<h2 mat-dialog-title class="dialog-title">Gebäude bearbeiten</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmGebaeude">
    <div class="form-group">
      <input type="hidden" formControlName="standort_id" />
    </div>
    <div class="form-group">
      <label class="form-label" for="name">Gebäude Name</label>
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Gebäude Name eingeben" />
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="onDelete()">Löschen</button>
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>

